"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var volume_1 = require("memfs/lib/volume");

var memfs_1 = require("memfs");

var ProxyFs = function () {
  function ProxyFs(vol, containerFs) {
    this.vol = vol;
    this.containerFs = containerFs;

    for (var _i = 0, _a = Object.keys(memfs_1.fs.promises); _i < _a.length; _i++) {
      var method = _a[_i];
      this[method] = memfs_1.fs.promises[method].bind(this);
    }
  }

  ProxyFs.createProxyFs = function (vol, containerFs) {
    function traceMethodClass(obj) {
      var handler = {
        get: function get(target, propKey, receiver) {
          var targetValue = Reflect.get(target, propKey, receiver);

          if (typeof targetValue === 'function') {
            return function () {
              var args = [];

              for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
              }

              return __awaiter(this, void 0, void 0, function () {
                var fsResult, tmpFs, promiseP, memFs;

                var _a;

                return __generator(this, function (_b) {
                  switch (_b.label) {
                    case 0:
                      console.log('CALL', propKey, args);
                      if (!containerFs[propKey]) throw 'Method not implemented in ContainerFS';
                      if (!(propKey === 'readdir' || propKey === 'readFile')) return [3, 2];
                      return [4, containerFs[propKey].apply(containerFs, args)];

                    case 1:
                      fsResult = _b.sent();

                      if (propKey === 'readFile') {
                        tmpFs = {};
                        tmpFs[args[0]] = fsResult;
                        vol = volume_1.Volume.fromJSON(Object.assign(vol.toJSON(), tmpFs));
                      }

                      return [2, fsResult];

                    case 2:
                      promiseP = [(_a = vol.promises)[propKey].apply(_a, args), containerFs[propKey].apply(containerFs, args)];
                      return [4, Promise.all(promiseP)];

                    case 3:
                      memFs = _b.sent()[0];
                      return [2, memFs];
                  }
                });
              });
            };
          } else {
            return targetValue;
          }
        }
      };
      return new Proxy(obj, handler);
    }

    return traceMethodClass(new ProxyFs(vol, containerFs));
  };

  return ProxyFs;
}();

exports.default = ProxyFs;